import { Employees } from 'modules/employees/store/collections/employees'

import type Membership from './models/Membership'

export const membershipEmployee = (employees: Employees, membership: Membership) => {
  return employees.relatedTo(membership)
}
